module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "task-images"
    }
  }, _vm._l((_vm.imageProps), function(props) {
    return _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.hasImageAt(props)),
        expression: "hasImageAt( props )"
      }],
      staticClass: "image",
      class: _vm.getClass(props),
      style: (_vm.getStyle(props)),
      attrs: {
        "src": _vm.getSource(props)
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-948d5b90"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TaskImages.vue
// module id = 443
// module chunks = 0